import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { Badge } from "@/shared/components/ui/badge";

import type { JobApplicantsResponse } from "@/modules/hrPortal/types";

interface JobInfoCardProps {
  data: JobApplicantsResponse;
}

export default function JobInfoCard({
  data,
}: JobInfoCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{data.job?.title || "Job"}</CardTitle>

        <p className="text-sm text-slate-500">
          {data.job?.department || "N/A"}
          {" • "}
          {data.job?.location || "N/A"}
        </p>
      </CardHeader>

      <CardContent>
        <div className="flex items-center justify-between">
          <span>Total Applicants</span>

          <Badge>{data.totalApplications}</Badge>
        </div>
      </CardContent>
    </Card>
  );
}
